if (!customElements.get('bm-design-stories')) {
  customElements.define('bm-design-stories', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const jump = this.querySelector('[data-stories-jump]');
      if (jump) {
        jump.closest('.bm-stories__jump').hidden = false;
        this.setAttribute('data-enhanced', '');
        jump.addEventListener('change', () => {
          const target = document.getElementById(jump.value);
          if (!target || !this.contains(target)) return;
          history.pushState(null, '', `#${encodeURIComponent(target.id)}`);
          this.navigate(target);
          jump.value = '';
        }, options);
      }
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (target && this.contains(target)) target.focus({ preventScroll: true });
        // Let the browser handle the anchor, including history and no-JS visits.
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        if (!(event.target instanceof Element) || !this.contains(event.target)) return;
        const target = event.target.closest('.bm-stories__group');
        if (target) this.navigate(target, true);
      }, options);
    }

    navigate(target, immediate = false) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: immediate || reducedMotion ? 'instant' : 'smooth', block: 'start' });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
